module.exports = __webpack_public_path__ + "img/independent1.a994e349.png";